<template>
    <div class="px-5">

        <div class="row py-5">



            <div class="col-sm-2 pointer" @click="openAvatarUpload">
                <img class="avatarImage" :src="company.imageLogo" v-if="company.imageLogo" />
                <img v-else class="avatarImage" src="/static/images/auth/supplier.jpg" alt="">
                <input type="file" class="hidden" ref="a" @change="receiveImage" />
            </div>

            <div class="col-sm-6">
                <div class="col-sm-6 mb-2" :class="{ error: $v.company.brand.$invalid }">
                    <div>
                        <label class="full">
                            Brand Name
                            <span class="brand">
                                *
                            </span>
                            <input type="text" class="bg-lighter" v-model="company.brand" @input="$v.company.brand.$touch">
                        </label>

                        <div v-if="$v.company.brand.$invalid" class="messages">
                            <span v-if="!$v.company.brand.required">Brand Name is required.</span>
                            <span v-if="!$v.company.brand.minLength">Must have at least 4 characters</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-sm-4 mb-2 text-right">
                <input type="submit" value="Save" class="btn widest ml-auto" :disabled="$v.company.$invalid" @click="save">
            </div>

        </div>

        <div class="row">

            <div class="col-md-8">

                <div>
                    <div class=" border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Company Details
                    </div>

                    <div class="mb-5"> <!-- company details block -->

                            <div class="row">
                                <div class="col-sm-8 mb-2" :class="{ error: $v.company.companyName.$invalid }">
                                    <label class="full">
                                        Company Name
                                        <span class="brand">
                                            *
                                        </span>
                                        <input type="text" class="bg-lighter" v-model="company.companyName" @input="$v.company.companyName.$touch">
                                    </label>

                                    <div v-if="$v.company.companyName.$invalid" class="messages">
                                        <span v-if="!$v.company.companyName.required">Company Name is required.</span>
                                    </div>

                                </div>

                                <div class="col-sm-4 mb-2">
                                    <label class="full">
                                        Website
                                        <input type="text" class="bg-lighter" v-model="company.website" >
                                    </label>
                                </div>

                            </div>


                            <div class="col-sm-12 p-0" :class="{ error: $v.company.companyAddress.$invalid }">
                                <label class="full">
                                    Company Address
                                    <span class="brand">
                                        *
                                    </span>
                                    <textarea class="bg-lighter" rows="2" v-model="company.companyAddress"  @input="$v.company.companyAddress.$touch"></textarea>
                                </label>

                                <div v-if="$v.company.companyAddress.$invalid" class="messages">
                                    <span v-if="!$v.company.companyAddress.required">Company Address is required.</span>
                                </div>

                            </div>

                            <div class="row mt-2"> <!-- group of 3 -->
                                <div class="col-sm-4 py-0 mb-2" :class="{ error: $v.company.postalCode.$invalid }">
                                    <label class="full">
                                        ZIP-Code
                                        <span class="brand">
                                            *
                                        </span>
                                        <input type="text" class="bg-lighter" v-model="company.postalCode" @input="$v.company.postalCode.$touch">
                                    </label>

                                    <div v-if="$v.company.postalCode.$invalid" class="messages">
                                        <span v-if="!$v.company.postalCode.required">ZIP-Code is required.</span>
                                    </div>

                                </div>
                                <div class="col-sm-4 py-0 mb-2" :class="{ error: $v.company.location.$invalid }">
                                    <label class="full">
                                        Location
                                        <span class="brand">
                                            *
                                        </span>
                                        <input type="text" class="bg-lighter" v-model="company.location" @input="$v.company.location.$touch">
                                    </label>

                                    <div v-if="$v.company.location.$invalid" class="messages">
                                        <span v-if="!$v.company.location.required">Location is required.</span>
                                    </div>

                                </div>
                                <div class="col-sm-4 py-0 mb-2">
                                    <label class="full">
                                        Country
                                        <span class="brand">
                                            *
                                        </span>
                                    </label>

                                    <vSelect
                                    v-model="selectedCountry"
                                    :options="countriesStored"
                                    :on-change="setCountryId">
                                  </vSelect>

                                  <div v-if="$v.company.country.$invalid" class="messages error">
                                      <span v-if="!$v.company.country.required">Country is required.</span>
                                  </div>

                                </div>
                            </div>

                            <div class="row mt-2"> <!-- group of 3 -->
                                <div class="col-sm-4 py-0 mb-2">
                                    <label class="full">
                                        License Number
                                        <input type="text" class="bg-lighter" v-model="company.licenseNumber">
                                    </label>

                                </div>
                                <div class="col-sm-4 py-0 mb-2">
                                    <label class="full">
                                        CAE
                                        <input type="text" class="bg-lighter" v-model="company.cae">
                                    </label>
                                </div>
                                <div class="col-sm-4 py-0 mb-2">
                                    <label class="full">
                                        VAT Number
                                        <input type="text" class="bg-lighter" v-model="company.registrationNumber">
                                    </label>
                                </div>
                            </div>

                            <div class="row mt-2"> <!-- group of 2 -->
                                <div class="col-sm-4 py-0 mb-2">
                                    <label class="full">
                                        Registry office
                                        <input type="text" class="bg-lighter" v-model="company.registryOffice">
                                    </label>
                                </div>
                            </div>

                    </div>
                </div>

                <div>
                    <div class=" border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Bio
                    </div>

                    <div class="mb-5">

                        <div class="row">
                            <div class="col-sm-8 mb-2">
                                <label class="full">
                                    Company Bio
                                    <textarea class="bg-lighter" rows="4" v-model="company.biography" placeholder="Write a small biography describing your company."></textarea>
                                </label>


                            </div>

                        </div>

                    </div>

                </div>

                <div>
                    <div class=" border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Contacts
                    </div>

                    <div class="mb-5"> <!-- contacts block -->
                        <!-- <div class="row mt-2" v-for="(contact, index) in company.details.contacts">
                            <div class="col-sm-8 py-0 mb-2">
                                <label class="full">
                                    Email {{index + 1}}
                                    <input type="text" class="bg-lighter" v-model="contact.email">
                                </label>
                            </div>
                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Phone {{index + 1}}
                                    <input type="text" class="bg-lighter" v-model="contact.phone">
                                </label>
                            </div>
                        </div> -->

                        <div class="row mt-2"> <!-- group of 2 -->
                            <div class="col-sm-8 py-0 mb-2" :class="{ error: $v.company.reservationEmail.$error }">
                                <label class="full">
                                    <span>Email - Reservations</span> <span class="normal fs-smaller">(you can enter multiple emails by separating them with comma ",")</span>
                                    <input type="text" class="bg-lighter" v-model="company.reservationEmail" @input="$v.company.reservationEmail.$touch" placeholder="email1@domain.com, email2@domain.com, email3@domain.com">
                                </label>
                                <div v-if="$v.company.reservationEmail.$error" class="messages">
                                    <span v-if="!$v.company.reservationEmail.isEmailValid">Invalid email.</span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">
                                <label class="full">
                                    Phone - Reservations
                                    <input type="text" class="bg-lighter" v-model="company.reservationPhone">
                                </label>
                            </div>
                        </div>

                        <div class="row mt-2"> <!-- group of 2 -->
                            <div class="col-sm-8 py-0 mb-2" :class="{ error: $v.company.financialEmail.$error }">
                                <label class="full">
                                    <span>Email - Financial</span> <span class="normal fs-smaller">(you can enter multiple emails by separating them with comma ",")</span>
                                    <input type="text" class="bg-lighter" v-model="company.financialEmail" @input="$v.company.financialEmail.$touch" placeholder="email1@domain.com, email2@domain.com, email3@domain.com">
                                </label>
                                <div v-if="$v.company.financialEmail.$error" class="messages">
                                    <span v-if="!$v.company.financialEmail.isEmailValid">Invalid email.</span>
                                </div>
                            </div>

                            <div class="col-sm-4 py-0 mb-2">

                            </div>
                        </div>
                        

                    </div>
                </div>

                <div>
                    <div class=" border-bottom-medium font-weight-600 darker pb-1 mb-3">
                        Calendar
                    </div>

                    <div class="row mt-2"> <!-- group of 3 -->
                        <div class="col-sm-4 py-0 mb-2">
                            <label class="full">
                                Start Hour
                            </label>
                            <timepicker format="hh:mm" :showOnTop="true" :availableHours="possibleCalendarHours" :defaultTime="defaultCalendarStartHour" @change="setCalendarStartTime"></timepicker>
                        </div>


                    </div>
                </div>

            </div>

            <div class="col-md-4">
                <div class=" border-bottom-medium font-weight-600 darker pb-1 mb-3">
                    Advanced Details
                </div>

                <div class="col-sm-12 p-0 mb-2">
                    <label class="full">
                        <span class="fs-small">Choose the best option to describe your offer.</span>
                    </label>
                    <v-select class="bg-lighter" label="description" :options="describeOffer" v-model="selectedDescribeOffer" :onChange="setOfferType"></v-select>
                </div>

                <div class="col-sm-12 p-0 mb-2" :class="{ error: $v.company.tagline.$invalid }">
                    <label class="full">
                        Tagline
                        <span class="brand">
                            *
                        </span>
                        <input type="text" class="bg-lighter" v-model="company.tagline" @input="$v.company.tagline.$touch">
                    </label>

                    <div v-if="$v.company.tagline.$invalid" class="messages">
                        <span v-if="!$v.company.tagline.required">Tagline is required.</span>
                        <span v-if="!$v.company.tagline.minLength">Must have at least 4 characters</span>
                    </div>
                </div>


                <!-- <div class="col-sm-12 p-0 mb-2">
                    <label class="full">
                        <div class="mb-2">Internal URL</div>
                        <div class="darkest">www.pluralo.com/{{company.companyURL}}</div>
                    </label>
                </div> -->

            </div>

            <div class="col-md-12 mb-2 text-right">
                <input type="submit" value="Save" class="btn widest ml-auto" :disabled="$v.company.$invalid" @click="save">
            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, email, minLength, helpers } from 'vuelidate/lib/validators'
    import Timepicker from '@/tools/Timepicker'

    export default {
        data: function() {
            return {
                describeOffer:[],
                selectedDescribeOffer:{},
                possibleCalendarHours:['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
            }
        },
        validations: {
            company:{
                brand:{
                    required,
                    minLength: minLength(4)
                },
                companyName:{
                    required,
                    minLength: minLength(4)
                },
                companyAddress: {
                    required
                },
                postalCode: {
                    required
                },
                postalCode: {
                    required
                },
                location: {
                    required
                },
                country: {
                    required
                },
                tagline:{
                    required,
                    minLength: minLength(4)
                },
                reservationEmail:{
                    isEmailValid: function (val) {
                        return this.validateEmailString(val)
                    }
                },
                financialEmail:{
                    isEmailValid: function (val) {
                        return this.validateEmailString(val)
                    }
                },
            }
        },
        computed:{
          ...mapGetters([
              'getCountries'
          ]),
          countriesStored: function() {
              let output = [];

              for (let country of this.getCountries) {
                output.push({
                  label: country.name,
                  value: country.id
                });
              }
              return output;
          },
            selectedCountry:{
                get: function(){
                    for (let country of this.getCountries) {
                        if(country.id == this.company.country){
                            return {
                                label: country.name,
                                value: country.id
                            }
                        }
                    }

                }
            },
          selectedOfferType:{
                get: function(){
                    for (let offerType of this.describeOffer) {
                        if(offerType.id == this.company.offerType){
                            return {
                                label: offerType.name,
                                value: offerType.id
                            }
                        }
                    }

                }
            },
            defaultCalendarStartHour: function(){
                if(this.company.calendarTimeStart){
                    return this.company.calendarTimeStart.split(':');
                } else {
                    return ['08', '00'];
                }
            },
            defaultCalendarEndHour: function(){
                if(this.company.calendarTimeEnd){
                    return this.company.calendarTimeEnd.split(':');
                } else {
                    return ['24', '00'];
                }
            }
        },
        asyncComputed: {
            async offerTypes() {
                try {
                    let response = await axios.get('/api/settings/GetSupplierOfferTypes');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {


                        this.describeOffer = response.data;
                        this.setDefaultOfferType;

                        //sets the dropdown with the correct initial offerType from API
                        for (let offerTypeOption of this.describeOffer) {
                          if(offerTypeOption.id == this.company.offerType){
                              this.selectedDescribeOffer = offerTypeOption;
                          }
                        }

                        if(Object.keys(this.selectedDescribeOffer).length === 0){
                          this.selectedDescribeOffer = this.describeOffer[0];
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        methods:{
            ...mapActions([
              'initGeography',
              'saveSettingsCompany'
            ]),
            validateEmailString: function (val) {
                if(!val || val == null || val == ""){
                    return false;
                }


                let isValid = true
                let separator
                if(val.includes(",")){
                    separator = ","
                } else if (val.includes(";")) {
                    separator = ";"
                }
                let emailArray = val.split(separator)

                // regex
                var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

                for (var i = 0; i < emailArray.length; i++) {
                    var email = emailArray[i].trim()
                    var thisEmailIsValid = re.test(email)
                    if(thisEmailIsValid === false){
                        isValid = false
                    }
                }

                return isValid;
            },
            setCountryId: function(selectedCountry){
              let oldCountry = this.company.country;

              if(selectedCountry !== null){
                  this.company.country = selectedCountry.value;
                  if(typeof this.company.country === 'undefined'){
                    this.company.country = oldCountry;
                  }
              }

              this.$v.company.country.$touch()

            },
            setOfferType: function(offerType){
              let oldOfferType = this.company.offerType;
                this.company.offerType = offerType.id;
              if(typeof this.company.offerType === 'undefined'){
                this.company.offerType = oldOfferType;
              }

            },
            setCalendarStartTime: function(e){
                this.company.calendarTimeStart = e
            },
            setCalendarEndTime: function(e){
                this.company.calendarTimeEnd = (e == '24:00')? '23:59:59' : e;
            },
            openAvatarUpload: function() {
                this.$refs.a.click()
            },
            receiveImage: function(event) {
                let vm = this;
                var reader = new window.FileReader() // if window is not used it says File READER is not defined
                reader.onload = function (event) {
                  // dispatch fileAttached to state UI postEditor with event.target.result as read dataURL
                  let imageDataURL = event.target.result
                  vm.company.imageLogo = imageDataURL;
                  vm.company.imageLogoBase64 = imageDataURL;
                  //console.log(imageDataURL) // or previewFile
                }
                reader.readAsDataURL(event.target.files[0])
                //console.log(event);
            },
            save: function(){
                console.log('saving company settings');
                console.log(this.company);
                this.saveSettingsCompany(this.company);
            }
        },
        props: ['company'],
        components:{
            vSelect: extendedVSelect,
            Timepicker
        }
    }
</script>

<style scoped lang="scss">
    .avatarImage{max-width: 100%;}
    textarea{min-height: 77px;}
</style>



// WEBPACK FOOTER //
// TabCompany.vue?827a55b8